import { useEffect as e, useRef as t, useState as n } from "react";
//#region src/components/Header/desktop/useNavigationScroll.ts
var r = () => {
	let r = t(null), [i, a] = n(!1), [o, s] = n(!1);
	return e(() => {
		let e = r.current;
		if (!e) return;
		let t = () => {
			a(e.scrollWidth > e.clientWidth), s(e.scrollLeft + e.clientWidth >= e.scrollWidth - 1);
		};
		t(), e.addEventListener("scroll", t);
		let n = new ResizeObserver(t);
		return n.observe(e), () => {
			e.removeEventListener("scroll", t), n.disconnect();
		};
	}, []), {
		listRef: r,
		isOverflowing: i,
		isAtEnd: o,
		scrollHandler: (e) => {
			let t = r.current;
			if (!t) return;
			let n = e === "right" ? t.scrollWidth : 0;
			t.scrollTo({
				left: n,
				behavior: "smooth"
			});
		}
	};
};
//#endregion
export { r as useNavigationScroll };
